import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { IchQuerySorterConfig } from 'fa-kt.types';
import { IchService } from '../service';

@Component({
  selector: 'fa-kt-ich-sorter',
  templateUrl: './ich-sorter.component.html',
  styleUrls: ['./ich-sorter.component.css'],
})
export class IchSorterComponent {
  public IchSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public ich: IchService,
  ) {
    this.IchSorterConfig = IchQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
